import React, { useEffect, useRef } from 'react';
import { Navigate, useNavigate, useParams } from 'react-router-dom';
import '../styles/ti-artist.css';
import { NotFound } from './NotFound';
import { ARTIST_HTML } from './tripink/artistMarkup';
import { initArtist } from './tripink/artistInit';
import { TI_ARTIST_SLUGS } from './tripink/artistSlugs';
import { mountShell } from './tripink/shell';

/* v5 artist page (approved 2026-10-14), one template for all 7 artists: /artist/<slug>.
   Artist data (bio facts, work, design concepts) lives in the ARTISTS array in tripink/artistInit.ts. */
const OLD_SLUGS: Record<string, string> = {
  sophia: 'sophia-mae'
};
export function ArtistDetail() {
  const {
    slug = ''
  } = useParams();
  const ref = useRef<HTMLDivElement>(null);
  const navigate = useNavigate();
  const navRef = useRef(navigate);
  navRef.current = navigate;
  const known = TI_ARTIST_SLUGS.includes(slug);
  useEffect(() => {
    const root = ref.current;
    if (!root || !known) return;
    root.innerHTML = ARTIST_HTML;
    const undoShell = mountShell(root, to => navRef.current(to), {
      title: 'Trip Ink Tattoo | Las Vegas Tattoo Artist',
      scrollPadding: '90px',
      background: '#020203'
    });
    const cleanup = initArtist(root, slug);
    return () => {
      cleanup();
      undoShell();
      root.innerHTML = '';
    };
  }, [slug, known]);
  if (OLD_SLUGS[slug]) return <Navigate to={`/artist/${OLD_SLUGS[slug]}`} replace data-id="element-231" data-mp="19ape8ne2k5h2" />;
  if (!known) return <NotFound data-id="element-232" data-mp="vg599a6txiii" />;
  return <div ref={ref} className="ti-artist" key={slug} data-id="element-233" data-mp="vfn5ztlr2413" />;
}